import { Tool, ToolType } from './tool';
import { LevelDesignerComponent } from '../level-designer/level-designer.component';
import { ToolGroup } from './tool-group';

export class UndoTool extends Tool {
    constructor(canvas: HTMLCanvasElement, levelDesigner: LevelDesignerComponent, toolGroup: ToolGroup) {
        super(canvas, levelDesigner, toolGroup, ToolType.Button, 'assets/icons/undo.svg');
    }

    public override getName(): string {
        return 'Undo';
    }

    public override getTooltip(): string {
        return 'Undo (Ctrl+Z)';
    }

    public override activate(): void {
        this.levelDesigner.undo();
    }

    public override onKeyPress(key: string): void {
        // Ctrl+Z is handled by the level designer.
    }
}
